export const cliqueNoData = ['1007', '1065', '1011', '1010', '1063', '1012', '1051', '1023', '1024', '1061', '1006', '1002', '1003'];



// WEBPACK FOOTER //
// ./src/assets/js/data.js